import CompaniesModalBody from "./CompaniesModalBody";

export default CompaniesModalBody;
